import User from "admin/types/interfaces/user";
import queryString from "query-string";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const useUsers = (
  {
    searchQuery,
    activeOnly = false,
    enabled = true,
    // Auth0 enrichment (last login, login count) costs a full Auth0 directory
    // fetch server-side on every request. Pass false unless those fields are read.
    withAuth0 = true,
    limit,
  }: {
    searchQuery?: string;
    activeOnly?: boolean;
    enabled?: boolean;
    withAuth0?: boolean;
    limit?: number;
  } = {},
  options?: SWRConfiguration
) => {
  const qs = queryString.stringify({
    with_auth0: withAuth0,
    include_system_users: false,
    ...(searchQuery && { q: searchQuery }),
    ...(activeOnly && { active_only: activeOnly }),
  });
  const url = enabled ? `${ACCESS_CONTROLLER_V1}/users?${qs}` : null;
  return useV1List<User>(url, { ...options, ...(limit !== undefined && { pageLimit: limit }) });
};

export default useUsers;
